export default __webpack_public_path__ + "static/media/iconEdit.f235e6e8.svg";